import { GlobalAxios } from "../axios/axios-config";
import { IBlacklist, IBlacklistGetById } from "../models/blacklist";

const BLACKLIST_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/BlackList/";

export class BlacklistService {
  create = (item: IBlacklist) => {
    return GlobalAxios.post(BLACKLIST_ROUTE, item);
  };

  getItemById = (id: string) => {
    return GlobalAxios.get<IBlacklistGetById>(BLACKLIST_ROUTE + id);
  };

  updateItemById = ({ item, id }: { item: IBlacklist; id: string }) => {
    return GlobalAxios.put(BLACKLIST_ROUTE + id, item);
  };
}
